const baseUrl = "https://api.defimoneymarket.com";

module.exports.baseUrl = baseUrl;